import { copyToClipboard } from "@/helpers/functions";
import { toast } from "react-toastify";

export default function GetLinkButton({ url }) {
    const handleCopy = (url) => {
        const toastId = toast.loading("Copying link...", {
            position: "bottom-right",
        });
        copyToClipboard(url);
        toast.update(toastId, {
            render: "Link copied successfully!",
            type: "success",
            isLoading: false,
            autoClose: 1500,
        });
    };

    return(
        <button
            onClick={() => handleCopy(url)}
            className="flex justify-end items-center gap-2 font-serif text-light px-2.5 py-1.5 hover:bg-light hover:text-white transition-colors duration-300 rounded-md"
        >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path  d="M13.8284 10.1716C12.2663 8.60948 9.73367 8.60948 8.17157 10.1716L4.17157 14.1716C2.60948 15.7337 2.60948 18.2663 4.17157 19.8284C5.73367 21.3905 8.26633 21.3905 9.82843 19.8284L10.93 18.7269M10.1716 13.8284C11.7337 15.3905 14.2663 15.3905 15.8284 13.8284L19.8284 9.82843C21.3905 8.26633 21.3905 5.73367 19.8284 4.17157C18.2663 2.60948 15.7337 2.60948 14.1716 4.17157L13.072 5.27118" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className="whitespace-nowrap">COPY LINK</span>
        </button>
    );
}
